import { Tooltip, Skeleton } from "@mui/material";
import {
    OfferStatusType,
    OrderStatusType,
} from "../../../../explorer/types/Basket/OfferOrderStatusType";
import {
    AppIconsCancelled,
    AppIconsOrdered,
    AppIconsSubmitted,
    AppIconsUnderCostruction,
} from "../../AppIcons";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";

type TOfferOrderStatusComponent = {
    item: any;
};

const getStatusIcon = (status: string, isOffer: boolean): JSX.Element => {
    if (isOffer) {
        const enumValue = Object.values(OfferStatusType).find(
            (value) => value === status
        );
        switch (enumValue) {
            case OfferStatusType.InPreparation:
                return <AppIconsUnderCostruction />;
            case OfferStatusType.Processed:
                return <AppIconsSubmitted />;
            case OfferStatusType.Ordered:
                return <AppIconsOrdered />;
            case OfferStatusType.Cancelled:
                return <AppIconsCancelled />;
            default:
                return <></>;
        }
    } else {
        const enumValue = Object.values(OrderStatusType).find(
            (value) => value === status
        );
        switch (enumValue) {
            case OrderStatusType.InProcess:
                return <AppIconsSubmitted />;
            case OrderStatusType.InPreparation:
                return <AppIconsUnderCostruction />;
            case OrderStatusType.Shipped:
                return <AppIconsOrdered />;
            case OrderStatusType.Cancelled:
                return <AppIconsCancelled />;
            default:
                return <></>;
        }
    }
};

const OfferOrderStatusIconComponent = (props: TOfferOrderStatusComponent) => {
    const { item } = props;

    const status = item.offerStatus || item.orderStatus;
    const { t } = useTranslation();
    return (
        <>
            {status ? (
                <Tooltip
                    children={getStatusIcon(
                        status,
                        item.offerStatus === status
                    )}
                    title={t(
                        `offerOrder.statusType.${status
                            .replace(/\s+/g, "")
                            .toLowerCase()}`
                    )}
                    placement="top"
                    disableInteractive
                />
            ) : (
                <Skeleton variant="circular" width={20} height={20} />
            )}
        </>
    );
};

export default OfferOrderStatusIconComponent;
